import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {ProcessFlatNode} from "../../../../../classes/process-flat-node";
import {FormTO} from "../../../../../classes/form-to";
import {ProcessBuilderService} from "../../../../../services/process-builder.service";
import {FormService} from "../../../../../services/form.service";

@Component({
  selector: 'sprout-designer-form-output',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './form-output.component.html',
  styleUrls: ['./form-output.component.css']
})
export class FormOutputComponent implements OnInit {

  form: FormTO;

  private formValue: any;

  @Input()
  processNode: ProcessFlatNode;

  @Output() formModelChangeEvent = new EventEmitter<string>();

  constructor(private formService: FormService, private processBuilderService: ProcessBuilderService, private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {

    if (this.processBuilderService.form && this.processBuilderService.form.id) {

      const formId: number = this.processBuilderService.form.id;
      const formTmp = new FormTO();
      formTmp.id = formId;

      this.formService.getFormTOModel(formTmp).subscribe(model => {

        if (model) {
          formTmp.model = JSON.stringify(model);

          this.processBuilderService.getFormModel(formId).subscribe(booleanTO => {
            if (booleanTO.message) {
              formTmp.value = booleanTO.message;
            }

            this.form = formTmp;

            if (this.processNode) {
              this.processBuilderService.processNode = this.processNode;
            } else {
              this.processNode = this.processBuilderService.processNode;
            }

            this.processNode.formId = this.form.id;
            this.changeDetectorRef.detectChanges();

          });
        }
      });
    }
  }

  timerAutoSave = -1;
  runnerAutoSave(parent: any) {
    this.timerAutoSave = -1;
    parent.formModelChangeEvent.emit(this.formValue);
  }

  onFormValueChange(formValue: any, parent: any) {
    // console.log('onFormValueChange.formValue!!!!!!!!!!:');
    // console.dir(formValue);
    // console.log('onFormValueChange.processNode:');
    // console.dir(this.processNode);

    if (formValue) {
      this.formValue = formValue;

      if (!this.timerAutoSave || this.timerAutoSave == -1) {
        this.timerAutoSave = setTimeout(function() {parent.runnerAutoSave(parent)}  , 2000); // auto-save every 5 seconds (assuming template has been changed)
      }
    }
  }

}

